import React from 'react';

/**
 * EtiquetaStatus — situação sempre com ícone e texto, nunca só cor.
 * tom: 'sucesso' | 'atencao' | 'perigo' | 'info' | 'neutro'
 * icone: troca o ícone padrão do tom quando a situação tem um próprio (ex.: "handshake").
 */
const ICONES = { sucesso: 'check_circle', atencao: 'warning', perigo: 'error', info: 'info', neutro: 'remove' };

export default function EtiquetaStatus({ tom = 'neutro', icone, children }) {
  return (
    <span className={`sj-status sj-status--${tom}`}>
      <span className="sj-icone" aria-hidden="true">{icone || ICONES[tom]}</span>
      {children}
    </span>
  );
}
